import { useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

import { useExaminationStore } from "store/useExaminationStore";
import { useSetCompletedForms } from "hooks/useSetCompletedForms";
import { QuestionnaireAgeNotBarrierForm, QuestionnaireFormWrapper } from "components/questionnaire";
import { questionnaireForms } from "components/questionnaire/consts";
import { requiredSelectNumber } from "../schemas";

const validationSchema = z.object({
    weightLossInLast6Months: requiredSelectNumber,
    limitationsDueToImpairedSenses: requiredSelectNumber,
    fallsOrInjuriesInLastYear: requiredSelectNumber,
    depressionOrAnxietyInLastWeeks: requiredSelectNumber,
    memoryOrientationPlanningIssues: requiredSelectNumber,
    urinaryIncontinence: requiredSelectNumber,
    mobilityDifficulties: requiredSelectNumber,
});

export const QuestionnaireAgeNotBarrier = ({ form, handleSaveForm, handleShowResult, isLoading }) => {
    const [startFillingTime] = useState(Date.now);
    const completedForms = useExaminationStore((state) => state.completedForms);
    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(validationSchema),
        defaultValues: {
            weightLossInLast6Months: {},
            limitationsDueToImpairedSenses: {},
            fallsOrInjuriesInLastYear: {},
            depressionOrAnxietyInLastWeeks: {},
            memoryOrientationPlanningIssues: {},
            urinaryIncontinence: {},
            mobilityDifficulties: {},
        },
    });
    useSetCompletedForms({ form, completedForms, setValue });

    const onSubmit = (data) => {
        handleSaveForm({ form, data, fillingTime: Date.now() - startFillingTime });
    };

    const onShowResult = (data) => {
        handleShowResult({
            form,
            values: data,
            formData: questionnaireForms[form],
        });
    };

    return (
        <QuestionnaireFormWrapper
            handleSubmit={handleSubmit(onSubmit)}
            handleShowResults={handleSubmit(onShowResult)}
            isLoading={isLoading}
        >
            <QuestionnaireAgeNotBarrierForm control={control} errors={errors} key={completedForms[form]} />
        </QuestionnaireFormWrapper>
    );
};
